import { getApi } from '@BUP/services/Axios'

export const fetchTranslations = async () => {
  const client = await getApi('schools', { version: 4 })
  return client
    .get('recommendations/translations')
    .then(response => response.data)
}
